import React, { useEffect, useState } from 'react';
// import BreadCrumb from '../../../../Components/Utils/Breadcrumbs';
import { BackButton, EditButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation, useParams } from 'react-router-dom';
import Dashboard from '../../../../Components/Icons/Dasboard';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { NormalHeading } from '../../../../Components/Utils/Heading';
import ApprovalComponent from '../../../../Components/Utils/approvalComponent';
import capitalizeFirstLetter from '../../../../Components/Utils/Funcs';
import { GetAccess, GetRole } from '../../../../Components/Utils/roles';
import Modal from '../../../../Components/Utils/AttachmentView';
import PDFViewer from '../../../../Components/Utils/PDFViewer';
import FilesView from '../../../../Components/Utils/FilesView';

const ViewRequest = () => {
  const { requestViewId,officeId } = useParams();
  const location = useLocation();
  const data = location.state.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  

    const id = requestViewId; 
    const getUrl = `/requests/get-status`;
    const putUrl = `/requests/edit-status`; 
    const statusUrl = '/requests/all-status';

    const EditAccess = "requests_edit"

    const [isModalOpen, setIsModalOpen] = useState(false);
      const [selectedImage, setSelectedImage] = useState(null);
      const [filePathList, setFilePathList] = useState([]);
    
      useEffect(() => {
        if (
          data?.attachments !== null &&
          data?.attachments !== "None" &&
          data?.attachments !== "[]"
        ) {
          setFilePathList(data?.attachments?.length>0 ? data?.attachments : []);
        }
      }, [data]);
    

  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="flex justify-end ">
      {/* <Breadcrumb
         items={
          [
            { name: "Store",
            link: `/main/${officeId}/main/${officeId}/store/requests` },
          {
            name: "Request",
            link: `/main/${officeId}/store/requests`
          },
          {
            name: "View Request"
          }]
         }
        /> */}
        <div className=" flex gap-2">
          <Link to={`/main/${officeId}/store/requests`} state={{currentPage:pageIndex,searchQuery:searchQuery!=""?searchQuery:""}}><BackButton link={true}/></Link>
          {data?.editable === false ? (
            <>
            {GetRole() && (
          <Link to={`/main/${officeId}/store/requests/edit/${data?.requestId}`} state={{data: data, from:`/main/${officeId}/store/requests/view/${data.requestId}`}}><EditButton height='8'/></Link>
          )}
          </>
        ) : (
        <>
        {GetAccess(EditAccess) && (
          <Link to={`/main/${officeId}/store/requests/edit/${data?.requestId}`} state={{data: data, from:`/main/${officeId}/store/requests/view/${data.requestId}`}}><EditButton height='8'/></Link>
          )}
          </>
          )
        }
        </div>
      </div>
      <div className="w-full mx-auto h-[calc(100vh-125px)]  rounded-md overflow-hidden p-2   flex gap-2 text-[#111537]">
        <div className="w-[70%]  bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden ">
        <div className="w-[98%]  bg-white px-2 mx-2 border border-gray py-2 rounded-lg flex justify-between items-center  z-10 mt-4">  
       

      <div className="grid items-center px-2 w-[70%]">
      <div className="flex text-[14px] mb-1 text-[#111537] font-semibold w-[90%]">
      <p className="  pr-[2px] ">{data?.ref || 'None'} </p>

                 </div>
            <div className="flex gap-4">
           
         <p className='text-xs text-[#111537]'>Request by : {data?.preparedByName  ? capitalizeFirstLetter(data?.preparedByName) : 'None'}</p>
         </div>
         </div>
         {/* <p className="bg-[#579BB1] text-white items-center rounded-md text-xs p-[2px]"> {data.status || 'None'}</p> */}
         <div className="border rounded-md mr-3 border-[#579BB1] text-xs inline-flex w-auto  flex-shrink-0  justify-center">
            <p className="  bg-white  text-black  p-1 rounded-l-md  ">
              Status  </p><p className="bg-[#579BB1] text-white p-1 items-center rounded-r-md"> {data.status || 'None'}</p>
             
              </div>
         
      
              </div>
              {/* <div className="h-[calc(100vh-200px)] overflow-y-auto p-2 pb-8"> */}

        <div className='w-[98%] flex flex-wrap px-2 border border-gary mt-4 mx-2 rounded-lg '>
          <div className="w-full grid grid-cols-2 gap-x-8 py-1">
           
           
          
                  <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Is Returnable</p>
                    <p className='w-[65%] py-2 text-xs  text-[#606279] pl-2 '>: {data?.isReturnable == true ? "Yes" : "No"}</p>
                  </div>
                
                   <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Issueed By</p>
                    <p className='w-[65%] py-2 text-xs  text-[#606279] pl-2 '>: {data?.issueedByName  ? capitalizeFirstLetter(data.issueedByName) : 'N/A'}</p>
                  </div>
               
          </div>
        </div>
        <div className="flex gap-4 mt-4 mx-2">
              <div className="w-[50%] ">
                <p className="  text-xs font-medium text-[#111537] p-1">
                  Comments
                </p>
                <div className="  border border-gary  h-28 overflow-y-scroll rounded-lg items-center">
                  <p className="  text-xs p-2 break-words text-[#606279]">
                    {data?.comments || "-"}
                  </p>
                </div>
              </div>
              <div className="w-[50%] ">
                <p className=" p-1 text-xs font-medium text-[#111537]">
                  Attachments
                </p>
                <div className=" border border-gary  overflow-y-scroll h-28 rounded-lg p-2">
                  {/* <SmallHeading title={"PR Attachments"} /> */}

                  <div className="w-full flex gap-2 flex-wrap ">
                    {data?.attachments &&
                      filePathList.map((imgs, idx) => {
                        console.log("img", imgs);
                        return (
                          <FilesView fileView={imgs} key={idx} />
                        );
                      })}
                  </div>
                </div>
              </div>
              
            </div>
            <div className="w-full bg-white  border border-gary  mt-4 rounded-lg ">
        <div className="w-full py-2 bg-baseColor-primary flex justify-between rounded-lg px-2">
            <p className="w-[5%]  text-left  text-white text-xs font-medium">S.N. </p>

            <p className="w-[40%]  text-left text-white text-xs font-medium">Product </p>
            <p className="w-[10%] text-center text-white text-xs font-medium">Unit</p>
   
            <p className="w-[20%] text-center text-white text-xs font-medium"> Quantity</p>
            <p className="w-[20%] text-center text-white text-xs font-medium"> Return Quantity</p>
            
               </div>
          {data?.products.map((List, index) => {
            return (
              <div key={index} className="w-full py-2 flex justify-between odd:bg-white even:bg-slate-100 px-2">
                
                 <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] py-1">
                                    {index + 1}
                                </p>
                <p className="w-[40%]  text-left  text-xs font-medium text-[#111537] py-1">
                  {List?.product_name}
                </p>
                <p className="w-[10%] text-center  text-xs font-medium text-[#111537] py-1">
                  {List?.unit}
                </p>
                
               
                <p className="w-[20%] text-center  text-xs font-medium text-[#111537] py-1">
                  {List?.quantity}
                </p>
            

                <p className=" w-[20%] text-center  text-xs font-medium text-[#111537] py-1">
                  {List.returnedQty }
                  
                  </p>
              </div>
            );
          })}
        </div>
      </div>
             
          
          <div className="w-[30%] h-full bg-white rounded-lg drop-shadow-lg py-2 ">
        <div className="h-[98%] overflow-y-scroll p-2 ">
<ApprovalComponent id={id} getUrl={getUrl} putUrl={putUrl} statusUrl={statusUrl} preUrlName={"requests"}/>
<div className="w-full grid  border border-gary mt-4  rounded-lg">
<div className="bg-baseColor-primary  p-2 rounded-t-lg">
            <p className="text-xs text-white font-medium">Request Detail</p>

            </div>
            <div className="w-full flex px-2 justify-between">
              <p className=" w-1/3 py-2 text-xs font-medium text-[#111537] ">
              Agent ID
              </p>
              <p className=" w-[65%] py-2 text-xs pl-5 text-[#606279] truncate">: {data?.requestId || '0'}
              </p>
            </div> 
            <div className="w-full flex px-2 justify-between">
              <p className=" w-1/3 py-2 text-xs font-medium text-[#111537]">
              Request For
              </p>
              <p className=" w-[65%] py-2 text-xs pl-5 text-[#606279] truncate">: {data?.requestFor || 'N/A'}
              </p>
            </div>
           
            <div className="w-full flex px-2 justify-between ">
  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
  Purpose
  </p>
  <p className=" w-[65%] py-2 text-xs pl-5 text-[#606279] truncate">: {data?.purpose || 'N/A'}
  </p>
</div>

            
         </div>
         </div>
         </div>
           </div>
           <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
          {selectedImage?.file.split(".").reverse()[0] == "pdf" ? (
            <PDFViewer pdfFile={selectedImage?.file} />
          ) : (
            <img src={selectedImage?.file} alt={selectedImage?.file} />
          )}
        </Modal>
              </div>
           
  
  )
};
export default ViewRequest;